<mat-card class="mb-2" *ngIf="data">
    <mat-card-content>
      <h3 class="info-title">{{data.title}}</h3>
  
      <div class="description">
       {{data.description}}
      </div>
  
      <div *ngIf="data.links?.length" class="files-list">
        <a *ngFor="let link of data.links" [target]="link.target" [href]="link.url" class="file-item">
          <mat-icon [svgIcon]="data.icon" class="square-icon file-icon"></mat-icon>
          {{ link.title }}
        </a>
      </div>
  
      <div *ngIf="data.buttonText && data.buttonLink" class="text-center mt-2">
        <app-portal-button 
            [target]="data.buttonTarget"
            [link]="data.buttonLink"
            classes="w-phone-100"
            color="primary" 
            [title]="data.buttonText"/>
      </div>
    </mat-card-content>
</mat-card>